import { inject, provideAppInitializer } from '@angular/core';

export * from './configuration';
export * from './security';
export * from './services';
export * from './messages';
export * from './toast';
export * from './models';
export * from './helpers';
export * from './data';
export * from './state-handler';
export * from './guards';
export * from './configuration/application-config';

import { SecurityServices } from './security';
import { ApplicationServices } from './services';
import { ToastService } from './toast';

export const CoreServices = [
    ...ApplicationServices,
    ...SecurityServices,
    ToastService,
    provideAppInitializer(() => {
      const initializerFn = ((toastService: ToastService) => () => toastService.startListening())(inject(ToastService));
      return initializerFn();
    })
];